export default {"src":"/_next/static/media/tag_icon.c7fecdbe.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};